import { isGrowthBookFeatureAllowed } from '../utils/growthbookFeatures';

export function useGrowthBook() {
  const { $growthbook } = useNuxtApp();
  const { growthbookFeatures } = useAppConfig();

  function getVariation<T>(featureKey: string, fallback: T): T {
    if (!$growthbook) return fallback;
    if (!isGrowthBookFeatureAllowed(featureKey, growthbookFeatures)) return fallback;
    return ($growthbook.getFeatureValue(featureKey, fallback) as T) ?? fallback;
  }

  return { getVariation };
}
